import { decodeJwt } from "jose";
import { useAuth } from "./useAuth";
import { DocumentationAreaId } from "src/contexts/documentationArea/domain/DocumentationAreaId";
import { ActorId } from "src/contexts/documentationArea/domain/ActorId";

type UseGetDataFromPermissoTokenResponse = {
  documentationAreaId: DocumentationAreaId;
  actorId?: ActorId;
  userId: string;
  expiresAt: number;
};

export const useGetDataFromPermissoToken = (): UseGetDataFromPermissoTokenResponse | null => {
  const { token, isLoginlessAccessToken } = useAuth();

  if (token && !isLoginlessAccessToken) return null;

  const data = decodeJwt(token);

  return {
    documentationAreaId: data["https://bankflip.io/docAreaId"] as DocumentationAreaId,
    actorId: data["https://bankflip.io/actorId"] as ActorId,
    userId: data.sub as string,
    expiresAt: data.exp as number,
  };
};
